<template>
  <div id='reg'>
      <div class="maincon">
      <van-divider>御和膳</van-divider>
      <div class='titlecon'>
          <div class="titlecon-line1">{{shareman}}</div>
          <div class="titlecon-line2">赠送您分享码{{sharecode}}</div>
      </div>
      <div class='loginform'>
          <div class='login-input'>
             <div class='login-input-icon'><Icon src='sj' class='login-input-svg'/></div><div class='login-input-content'> <input type='number' v-model='mobile' placeholder="请输入手机号码" readonly @click="showMobileInput=true"/></div>
          </div>
          <div class='login-input'>
             <div class='login-input-icon'><Icon src='yzm' class='login-input-svg'/></div><div class='login-input-content'> <input type='number' placeholder="请输入验证码" v-model='code' @click="showMobileInput=false" /></div>
             <div class="sendmsg-con" @click="getCode(1)">获取验证码</div>
          </div>
          <div class='login-input'>
            <div class='login-input-icon'><Icon src='username' class='login-input-svg'/></div><div class='login-input-content'> <input type='text' v-model='username' placeholder="请输入注册会员名"/></div>
          </div>
          <div class='login-input'>
            <div class='login-input-icon'><Icon src='password2' class='login-input-svg'/></div><div class='login-input-content'> <input type='password' v-model='password' placeholder="请输入登陆密码"/></div>
          </div>
          <div class='login-btn-con'>
              <button class='login-btn' block @click='doReg()'>马上注册</button>
          </div>    
      </div>    
      <van-number-keyboard
                        :show="showMobileInput"
                        theme="custom"
                        close-button-text="完成"
                        @blur="showMobileInput = false"
                        @input="onMobileInput"
                        @delete="onMobileDelete"
                        />   
      </div>                  
  </div>
</template>
<script>
import Icon from '@/components/icon'
import {NumberKeyboard,Divider } from 'vant'
export default {
   name: 'reg',
   data() {
        return {
          mobile:'',
          code:'',
          username:'',
          password:'',
          sharecode:'',
          shareman:'',
          showMobileInput:false,
          processing:false
        };
   }, 
   created(){
        this.getList()
   },
   methods: {
      getList(){
           if(this.$route.query.sharecode!=undefined && this.$route.query.sharecode!='') this.sharecode=this.$route.query.sharecode
           this.$post("/reg/getShareInfo",{sharecode:this.sharecode}).then((data)=>{
               if(data.result.success){
                   this.shareman=data.result.info.username
               }else{
                   this.$toast(data.result.info)
               }
           })
      },
      doReg(){
          if(this.processing){
              this.$toast("请等待处理完成")
              return false
          }
          if(this.mobile=='') {
              this.$toast("手机号码不能为空")
              return false
          }
          if(this.code=='') {
              this.$toast("验证码不能为空")
              return false
          }
          if(this.username==""){
             this.$toast("注册会员名称不能为空")
             return false
          }
          if(this.password==""){
             this.$toast("登陆密码不能为空")
              return false
          }
          if(this.sharecode==""){
             this.$toast("分享信息不能为空")
             return false
          }
          this.processing=true
          this.$post("/reg/doReg",{mobile:this.mobile,code:this.code,username:this.username,password:this.password,sharecode:this.sharecode}).then((data)=>{
              this.processing=false
              if(data.result.success){
                  this.$toast(data.result.info)
                  setTimeout(()=>{this.$go("/login")},1000)
              }else{
                  this.$toast(data.result.info)
              }
          })
      },
      getCode(type){
         if(this.mobile==''|| isNaN(this.mobile)){
            this.$toast("手机号码不正确")
            return false
         } 
         this.$post("/sms/getCode",{mobile:this.mobile,type:type}).then((data)=>{
              this.$toast(data.result.info)
         })
      },
      onMobileInput(input){
          this.mobile+=input
      },
      onMobileDelete(){
          this.mobile=this.mobile.slice(0,-1)
      }
   },
   components: {
        Icon,
        [NumberKeyboard.name]:NumberKeyboard,
        [Divider.name]:Divider 
   }
}
</script>
<style scoped>
#reg{background-color:#F6F6F6;min-height: 100vh;padding-top:60px;z-index:999;padding: 0 0.5rem;overflow:hidden;position: relative;margin:0 auto;max-width:640px;color:#2c3e50;}
.maincon{margin: 0 0.25rem;background-color: #fff;border-radius: 0.25rem;padding: 0.5rem;margin-top: 4rem;}
.titlecon{margin-top: 0.1rem;}
.titlecon-line1{color:#333;font-size:0.35rem;padding: 0.1rem;}
.titlecon-line2{color:#999;font-size:0.3rem}
.loginform{margin-top: 0.8rem;}
.title-con{padding: 0.3rem;}
.title{font-size:0.5rem;padding: 0.2rem;color:#facb97}
.subtitle{font-size:0.3rem;padding: 0 0.1rem 0.1rem;}
.login-btn-con{margin-top: 0.5rem;}
.login-btn{width: 100%;height: 1.067rem;color: #fff;text-align: center;line-height: 1.067rem;font-size: 0.36rem;border-radius: 0.2rem;background-image: linear-gradient(to right,#ff6034, #ee0a24);}
.login-input{background-color: #f8f8f8;height:1.2rem;margin-top: 0.2rem;border-radius: 0.2rem;display:flex;align-items: center;}
.login-input-icon{width:1.5rem;text-align: center;}
.login-input-svg{width:0.5rem;height:0.5rem;}
.login-input-content{flex:3;}
.login-input-content input{outline: none;border: none;background-color: #f8f8f8;height:1rem;line-height: 1rem;width:100%;font-size:0.4rem;border-radius: 0.2rem;color:#000000;}
.forget_password{margin-top: 0.4rem;color:#7AB5FB;font-size:0.3rem;letter-spacing: 1px;}
.bottomwords{text-align: center;font-size:0.25rem;color:#000000;position: absolute;bottom:0;left:0;width:100%;}
.sendmsg-con{color:#333;text-decoration: underline;width:2.5rem;text-align: center;font-size:0.35rem;padding: 0.1rem;}
.logo-line1{font-size:1.35rem;color:#000;}
.logo-line2{font-size:0.35rem;color:#000;}
</style>